<template>
  <div class="descritores-editor">
    <!-- Nível 0: Tópicos -->
    <div v-for="(topico, i0) in localItens" :key="'l0-' + i0" class="nivel-0-wrapper mb-4">
      <v-card outlined class="nivel-card nivel-0-card">
        <v-card-text class="pb-1">
          <!-- Cabeçalho nível 0 -->
          <div class="d-flex align-center nivel-0-header">
            <v-icon small color="teal darken-1" class="mr-2">mdi-folder-outline</v-icon>
            <span
              class="nivel-label teal--text text--darken-2 font-weight-medium text-caption text-uppercase mr-2"
            >
              Tópico
            </span>
            <v-spacer />
            <v-tooltip v-if="!podeRemover(topico)" bottom>
              <template #activator="{ on }">
                <v-btn icon small color="grey" v-on="on">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>Não é possível deletar tópico após criado</span>
            </v-tooltip>
            <v-btn v-else icon small color="error" @click="removerItem(localItens, i0)">
              <v-icon md>mdi-delete-outline</v-icon>
            </v-btn>
          </div>

          <v-row dense class="mt-4">
            <v-col cols="3">
              <ValidationProvider
                :name="`Número ${i0 + 1}`"
                :rules="{ required: true, max_chars: 20, no_special_chars: true }"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="topico.apelido"
                  label="Número *"
                  outlined
                  dense
                  hide-details="auto"
                  :error-messages="errors"
                  counter="20"
                  maxlength="20"
                  @input="emitir"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="9">
              <ValidationProvider
                :name="`Descrição do Tópico ${i0 + 1}`"
                :rules="{ required: true, max_chars: 200, no_special_chars: true }"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="topico.descricao"
                  label="Descrição do Tópico *"
                  outlined
                  dense
                  hide-details="auto"
                  :error-messages="errors"
                  counter="200"
                  maxlength="200"
                  @input="emitir"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-divider />
          <v-spacer />

          <!-- Nível 1: Descritores -->
          <div class="mt-2">
            <v-btn
              v-if="!topico.children.length"
              text
              small
              class="mb-2 nivel-1-btn"
              @click="adicionarFilho(topico.children)"
            >
              <v-icon small left>mdi-plus</v-icon>
              Adicionar Descritor
            </v-btn>
            <div
              v-for="(descritor, i1) in topico.children"
              :key="'l1-' + i0 + '-' + i1"
              class="nivel-1-wrapper mb-3"
            >
              <v-card outlined class="nivel-card nivel-1-card">
                <v-card-text class="pb-1">
                  <div class="d-flex align-center nivel-1-header">
                    <v-icon small color="blue-grey" class="mr-2">mdi-file-outline</v-icon>
                    <span
                      class="nivel-label nivel-1-label font-weight-medium text-caption text-uppercase mr-2"
                    >
                      Descritor
                    </span>
                    <v-spacer />
                    <v-tooltip v-if="!podeRemover(descritor)" bottom>
                      <template #activator="{ on }">
                        <v-btn icon small color="grey" v-on="on">
                          <v-icon small>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Não é possível deletar descritor após criado</span>
                    </v-tooltip>
                    <v-btn
                      v-else
                      icon
                      small
                      color="error"
                      @click="removerItem(topico.children, i1)"
                    >
                      <v-icon md>mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>

                  <v-row dense class="mt-1">
                    <v-col cols="3">
                      <ValidationProvider
                        :name="`Código ${i0 + 1}.${i1 + 1}`"
                        :rules="{ required: true, max_chars: 10, no_special_chars: true }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="descritor.apelido"
                          label="Código *"
                          outlined
                          dense
                          hide-details="auto"
                          :error-messages="errors"
                          counter="10"
                          maxlength="10"
                          @input="emitir"
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="9">
                      <ValidationProvider
                        :name="`Descritor ${i0 + 1}.${i1 + 1}`"
                        :rules="{
                          required: true,
                          max_chars: 500,
                          no_special_chars: true,
                        }"
                        v-slot="{ errors }"
                      >
                        <v-textarea
                          v-model="descritor.descricao"
                          label="Descritor *"
                          outlined
                          dense
                          rows="3"
                          auto-grow
                          hide-details="auto"
                          :error-messages="errors"
                          counter="500"
                          maxlength="500"
                          @input="emitir"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-btn
                    v-if="i1 === topico.children.length - 1"
                    text
                    small
                    class="mt-1 nivel-1-btn"
                    @click="adicionarFilho(topico.children)"
                  >
                    <v-icon small left>mdi-plus</v-icon>
                    Adicionar Descritor
                  </v-btn>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- Botão adicionar tópico -->
    <v-btn outlined color="teal darken-1" class="mt-2" @click="adicionarRaiz">
      <v-icon left small>mdi-plus</v-icon>
      Adicionar Tópico
    </v-btn>

    <div v-if="localItens.length === 0" class="text-center grey--text py-6">
      <v-icon size="40" color="grey lighten-2">mdi-playlist-plus</v-icon>
      <div class="mt-2 text-body-2">
        Nenhum tópico cadastrado. Clique em "Adicionar Tópico" para começar.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DescritoresEditor",

  props: {
    value: { type: Array, default: () => [] },
    editing: { type: Boolean, default: false },
  },

  data() {
    return { localItens: [] };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.localItens = this.deepClone(val || []);
      },
    },
  },

  methods: {
    podeRemover(item) {
      return !this.editing || !!(item && item.isNovo);
    },

    novoItem(extra = {}) {
      return { descricao: "", apelido: null, ordem: 0, children: [], isNovo: true, ...extra };
    },

    adicionarRaiz() {
      this.localItens.push(this.novoItem({ ordem: this.localItens.length }));
      this.emitir();
    },

    adicionarFilho(lista) {
      lista.push(this.novoItem({ ordem: lista.length }));
      this.emitir();
    },

    removerItem(lista, index) {
      lista.splice(index, 1);
      this.emitir();
    },

    emitir() {
      this.$emit("input", this.deepClone(this.localItens));
    },

    deepClone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
  },
};
</script>

<style scoped>
.descritores-editor {
  width: 100%;
}

.nivel-card {
  border-radius: 8px !important;
  transition: box-shadow 0.2s;
}

.nivel-0-card {
  border: 2px solid #00695c !important;
  background-color: #fafffe !important;
}

.nivel-1-card {
  border: 2px solid #3370b2 !important;
  background-color: #fafafa !important;
}

.nivel-0-header {
  background-color: #e0f2f0;
  margin: -16px -16px 8px -16px;
  padding: 8px 16px;
  border-radius: 6px 6px 0 0;
}

.nivel-1-header {
  background-color: #deeaf6;
  margin: -16px -16px 8px -16px;
  padding: 8px 16px;
  border-radius: 6px 6px 0 0;
}

.nivel-1-label {
  color: #3370b2 !important;
}

.nivel-1-btn {
  border: 1px solid #3370b2 !important;
  color: #3370b2 !important;
}

.nivel-label {
  letter-spacing: 0.06em;
  font-size: 10px !important;
}
</style>
